import { useCallback, useEffect } from 'react';
import { useBeforeUnload, useBlocker } from 'react-router-dom';

const warningMessage = 'You have unsaved changes. Leave this page and discard them?';

export const useAdminUnsavedChanges = (shouldBlock: boolean) => {
    const blocker = useBlocker(shouldBlock);

    useEffect(() => {
        if (blocker.state !== 'blocked') {
            return;
        }

        if (window.confirm(warningMessage)) {
            blocker.proceed();
        } else {
            blocker.reset();
        }
    }, [blocker]);

    useBeforeUnload(useCallback((event) => {
        if (!shouldBlock) {
            return;
        }

        event.preventDefault();
        event.returnValue = warningMessage;
    }, [shouldBlock]));
};
